import { render, staticRenderFns } from "./FrqModal.vue?vue&type=template&id=8fe758a6&scoped=true&lang=html&"
import script from "./FrqModal.vue?vue&type=script&lang=js&"
export * from "./FrqModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe758a6",
  null
  
)

export default component.exports